import { render, staticRenderFns } from "./FeeDetailFeeObj.vue?vue&type=template&id=b1ed3a82&scoped=true"
import script from "./FeeDetailFeeObj.vue?vue&type=script&lang=js"
export * from "./FeeDetailFeeObj.vue?vue&type=script&lang=js"
import style0 from "./FeeDetailFeeObj.vue?vue&type=style&index=0&id=b1ed3a82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ed3a82",
  null
  
)

export default component.exports